import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        containerClassName="!bottom-[max(1rem,env(safe-area-inset-bottom))]"
        toastOptions={{
          duration: 4500,
          className:
            '!bg-secondary-900 !text-secondary-100 !border !border-secondary-600/80 !shadow-xl',
          style: { fontSize: '0.925rem' },
        }}
      />
    </ErrorBoundary>
  </React.StrictMode>
);